export const ERROR_CHANNEL_NOT_DEFINED = 'Ошибка: не найден выбранный Waba канал'